import { Fragment } from "react";
import { Delete } from "@mui/icons-material";

import { DeleteDialog } from "@dzambalaorg/mui-dialog-delete";
import { PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { useUser } from "@dzambalaorg/provider-user";
import { useDialogDelete, useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { ListAction, ListActions, StyledListItem, StyledListWrapper } from "@framework/styled";
import { IOtp, IUser } from "@framework/types";
import { List } from "@dzambalaorg/ui-kit";

import { ITabPanelProps } from "../tabs";
import { InviteButton } from "./invite";

const MERCHANT_MANAGERS_URL = "/merchant/managers";

export const MerchantManagers = (props: ITabPanelProps) => {
  const { open } = props;

  const { isLoading, allRows, refetch } = useFetchQuery<IPaginationResult<IUser>>(MERCHANT_MANAGERS_URL);
  const { handleDelete } = useDialogDelete<IOtp>();
  const { profile } = useUser<IUser>();

  if (!open) {
    return null;
  }

  return (
    <Fragment>
      <PageHeader message="pages.merchant.tabs.managers">
        <InviteButton />
      </PageHeader>

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading} message="pages.merchant.managers.empty">
          {allRows.map(user => (
            <StyledListItem key={user.id}>
              <List.ItemText>{user.displayName}</List.ItemText>
              <ListActions>
                <ListAction
                  icon={Delete}
                  message="form.tips.delete"
                  onClick={handleDelete(user)}
                  disabled={user.id === profile.id}
                />
              </ListActions>
            </StyledListItem>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      <DeleteDialog url={MERCHANT_MANAGERS_URL} refetch={refetch} getTitle={(user: IUser) => user.displayName} />
    </Fragment>
  );
};
